import tag from 'queries/tag';
import useEntryContent from './useEntryContent';

const useTagContent = url => useEntryContent(url, tag.main);

export default useTagContent;
